import { useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { routes } from "@/routes";

export function Router() {
  const router = useMemo(() => createBrowserRouter(routes), []);

  return <RouterProvider router={router} />;
}
